<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_564_1415)">
        <path d="M24 4H0V19.5466H24V4Z" fill="#B22234" />
        <path
            d="M0 5.79395H24H0ZM24 8.18572H0H24ZM0 10.5775H24H0ZM24 12.9693H0H24ZM0 15.3611H24H0ZM24 17.7528H0H24Z"
            fill="black" />
        <path fill-rule="evenodd" clip-rule="evenodd"
            d="M24 6.39218H0V5.19629H24V6.39218ZM0 7.58807H24V8.78396H0V7.58807ZM24 11.1757H0V9.97985H24V11.1757ZM0 12.3716H24V13.5675H0V12.3716ZM24 15.9593H0V14.7634H24V15.9593ZM0 17.1552H24V18.3511H0V17.1552Z"
            fill="white" />
        <path d="M11.52 4H0V12.3712H11.52V4Z" fill="#3C3B6E" />
        <path
            d="M0.959988 4.3584L1.23413 5.22375L0.516418 4.68893H1.40356L0.685847 5.22375L0.959988 4.3584Z"
            fill="white" />
        <path
            d="M0.959988 6.03223L1.23413 6.89758L0.516418 6.36276H1.40356L0.685847 6.89758L0.959988 6.03223Z"
            fill="white" />
        <path
            d="M0.959988 7.70703L1.23413 8.57238L0.516418 8.03757H1.40356L0.685847 8.57238L0.959988 7.70703Z"
            fill="white" />
        <path
            d="M0.959988 9.38086L1.23413 10.2462L0.516418 9.71139H1.40356L0.685847 10.2462L0.959988 9.38086Z"
            fill="white" />
        <path
            d="M0.959988 11.0557L1.23413 11.921L0.516418 11.3862H1.40356L0.685847 11.921L0.959988 11.0557Z"
            fill="white" />
        <path
            d="M1.92001 5.19531L2.19415 6.06067L1.47644 5.52585H2.36358L1.64587 6.06067L1.92001 5.19531Z"
            fill="white" />
        <path
            d="M1.92001 6.86914L2.19415 7.73449L1.47644 7.19968H2.36358L1.64587 7.73449L1.92001 6.86914Z"
            fill="white" />
        <path
            d="M1.92001 8.54395L2.19415 9.4093L1.47644 8.87448H2.36358L1.64587 9.4093L1.92001 8.54395Z"
            fill="white" />
        <path
            d="M1.92001 10.2178L2.19415 11.0831L1.47644 10.5483H2.36358L1.64587 11.0831L1.92001 10.2178Z"
            fill="white" />
        <path
            d="M2.87997 4.3584L3.15411 5.22375L2.4364 4.68893H3.32354L2.60583 5.22375L2.87997 4.3584Z"
            fill="white" />
        <path
            d="M2.87997 6.03223L3.15411 6.89758L2.4364 6.36276H3.32354L2.60583 6.89758L2.87997 6.03223Z"
            fill="white" />
        <path
            d="M2.87997 7.70703L3.15411 8.57238L2.4364 8.03757H3.32354L2.60583 8.57238L2.87997 7.70703Z"
            fill="white" />
        <path
            d="M2.87997 9.38086L3.15411 10.2462L2.4364 9.71139H3.32354L2.60583 10.2462L2.87997 9.38086Z"
            fill="white" />
        <path
            d="M2.87997 11.0557L3.15411 11.921L2.4364 11.3862H3.32354L2.60583 11.921L2.87997 11.0557Z"
            fill="white" />
        <path
            d="M3.83999 5.19531L4.11413 6.06067L3.39642 5.52585H4.28356L3.56585 6.06067L3.83999 5.19531Z"
            fill="white" />
        <path
            d="M3.83999 6.86914L4.11413 7.73449L3.39642 7.19968H4.28356L3.56585 7.73449L3.83999 6.86914Z"
            fill="white" />
        <path
            d="M3.83999 8.54395L4.11413 9.4093L3.39642 8.87448H4.28356L3.56585 9.4093L3.83999 8.54395Z"
            fill="white" />
        <path
            d="M3.83999 10.2178L4.11413 11.0831L3.39642 10.5483H4.28356L3.56585 11.0831L3.83999 10.2178Z"
            fill="white" />
        <path
            d="M4.80002 4.3584L5.07416 5.22375L4.35645 4.68893H5.24358L4.52587 5.22375L4.80002 4.3584Z"
            fill="white" />
        <path
            d="M4.80002 6.03223L5.07416 6.89758L4.35645 6.36276H5.24358L4.52587 6.89758L4.80002 6.03223Z"
            fill="white" />
        <path
            d="M4.80002 7.70703L5.07416 8.57238L4.35645 8.03757H5.24358L4.52587 8.57238L4.80002 7.70703Z"
            fill="white" />
        <path
            d="M4.80002 9.38086L5.07416 10.2462L4.35645 9.71139H5.24358L4.52587 10.2462L4.80002 9.38086Z"
            fill="white" />
        <path
            d="M4.80002 11.0557L5.07416 11.921L4.35645 11.3862H5.24358L4.52587 11.921L4.80002 11.0557Z"
            fill="white" />
        <path
            d="M5.76004 5.19531L6.03418 6.06067L5.31647 5.52585H6.20361L5.4859 6.06067L5.76004 5.19531Z"
            fill="white" />
        <path
            d="M5.76004 6.86914L6.03418 7.73449L5.31647 7.19968H6.20361L5.4859 7.73449L5.76004 6.86914Z"
            fill="white" />
        <path
            d="M5.76004 8.54395L6.03418 9.4093L5.31647 8.87448H6.20361L5.4859 9.4093L5.76004 8.54395Z"
            fill="white" />
        <path
            d="M5.76004 10.2178L6.03418 11.0831L5.31647 10.5483H6.20361L5.4859 11.0831L5.76004 10.2178Z"
            fill="white" />
        <path d="M6.72 4.3584L6.99414 5.22375L6.27643 4.68893H7.16357L6.44586 5.22375L6.72 4.3584Z"
            fill="white" />
        <path
            d="M6.72 6.03223L6.99414 6.89758L6.27643 6.36276H7.16357L6.44586 6.89758L6.72 6.03223Z"
            fill="white" />
        <path
            d="M6.72 7.70703L6.99414 8.57238L6.27643 8.03757H7.16357L6.44586 8.57238L6.72 7.70703Z"
            fill="white" />
        <path
            d="M6.72 9.38086L6.99414 10.2462L6.27643 9.71139H7.16357L6.44586 10.2462L6.72 9.38086Z"
            fill="white" />
        <path d="M6.72 11.0557L6.99414 11.921L6.27643 11.3862H7.16357L6.44586 11.921L6.72 11.0557Z"
            fill="white" />
        <path
            d="M7.68002 5.19531L7.95416 6.06067L7.23645 5.52585H8.12359L7.40588 6.06067L7.68002 5.19531Z"
            fill="white" />
        <path
            d="M7.68002 6.86914L7.95416 7.73449L7.23645 7.19968H8.12359L7.40588 7.73449L7.68002 6.86914Z"
            fill="white" />
        <path
            d="M7.68002 8.54395L7.95416 9.4093L7.23645 8.87448H8.12359L7.40588 9.4093L7.68002 8.54395Z"
            fill="white" />
        <path
            d="M7.68002 10.2178L7.95416 11.0831L7.23645 10.5483H8.12359L7.40588 11.0831L7.68002 10.2178Z"
            fill="white" />
        <path
            d="M8.63998 4.3584L8.91412 5.22375L8.19641 4.68893H9.08355L8.36584 5.22375L8.63998 4.3584Z"
            fill="white" />
        <path
            d="M8.63998 6.03223L8.91412 6.89758L8.19641 6.36276H9.08355L8.36584 6.89758L8.63998 6.03223Z"
            fill="white" />
        <path
            d="M8.63998 7.70703L8.91412 8.57238L8.19641 8.03757H9.08355L8.36584 8.57238L8.63998 7.70703Z"
            fill="white" />
        <path
            d="M8.63998 9.38086L8.91412 10.2462L8.19641 9.71139H9.08355L8.36584 10.2462L8.63998 9.38086Z"
            fill="white" />
        <path
            d="M8.63998 11.0557L8.91412 11.921L8.19641 11.3862H9.08355L8.36584 11.921L8.63998 11.0557Z"
            fill="white" />
        <path d="M9.6 5.19531L9.87414 6.06067L9.15643 5.52585H10.0436L9.32586 6.06067L9.6 5.19531Z"
            fill="white" />
        <path d="M9.6 6.86914L9.87414 7.73449L9.15643 7.19968H10.0436L9.32586 7.73449L9.6 6.86914Z"
            fill="white" />
        <path d="M9.6 8.54395L9.87414 9.4093L9.15643 8.87448H10.0436L9.32586 9.4093L9.6 8.54395Z"
            fill="white" />
        <path d="M9.6 10.2178L9.87414 11.0831L9.15643 10.5483H10.0436L9.32586 11.0831L9.6 10.2178Z"
            fill="white" />
        <path
            d="M10.56 4.3584L10.8341 5.22375L10.1164 4.68893H11.0035L10.2858 5.22375L10.56 4.3584Z"
            fill="white" />
        <path
            d="M10.56 6.03223L10.8341 6.89758L10.1164 6.36276H11.0035L10.2858 6.89758L10.56 6.03223Z"
            fill="white" />
        <path
            d="M10.56 7.70703L10.8341 8.57238L10.1164 8.03757H11.0035L10.2858 8.57238L10.56 7.70703Z"
            fill="white" />
        <path
            d="M10.56 9.38086L10.8341 10.2462L10.1164 9.71139H11.0035L10.2858 10.2462L10.56 9.38086Z"
            fill="white" />
        <path
            d="M10.56 11.0557L10.8341 11.921L10.1164 11.3862H11.0035L10.2858 11.921L10.56 11.0557Z"
            fill="white" />
    </g>
    <defs>
        <clipPath id="clip0_564_1415">
            <rect width="24" height="24" fill="white" />
        </clipPath>
    </defs>
</svg>
    
